export function scheduleIdleCallback(
  callback: () => void,
  options?: { timeout?: number },
): void {
  if (typeof requestIdleCallback !== 'undefined') {
    requestIdleCallback(callback, options)
  }
  else if (typeof requestAnimationFrame !== 'undefined') {
    requestAnimationFrame(() => setTimeout(callback, 1))
  }
  else {
    setTimeout(callback, Math.min(options?.timeout ?? 50, 50))
  }
}
